export default __webpack_public_path__ + "static/media/card-template-fb.901411f7.png";